/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

const Params = z.strictObject({ requestId: z.string().min(1) });

export const JiraRequestCommentsGet = {
  id: 'jira-request-comments.get',
  tag: 'Support',
  summary: 'Jira request comments',
  description: 'Get jira request comments',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/jira/request/${params.requestId}/comments`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
